<template>
  <div
    class="d-flex-column justify-start align-start gap-20"
    style="margin-top: 12px"
  >
    <h4 class="t-white font-family-1 title-h5 f-w-600">
      {{ $t("calculators_common.select_queue") }}
    </h4>

    <div
      class="justify-start exptra_options picker_option_container queue flex-wrap"
    >
      <div
        class="picker_option queue d-flex-column space-between gap-5 align-start"
        :class="[
          packOption?.id === checkoutStore.getSelectedQueue?.value &&
            'selected',
        ]"
        v-for="packOption in packOptions"
        :key="packOption"
        @click="() => selectOption(packOption)"
      >
        <div class="d-flex-row justify-start gap-0">
          <p class="t-white medium-l font-family-2">
            {{ packOption.title }}
          </p>
        </div>
        <div class="d-flex-row space-between">
          <h4 class="font-family-2 regular-m t-grey">
            {{ renderDesc(packOption).description }}
            <span class="t-light-blue">
              {{ renderDesc(packOption).type }}{{ renderDesc(packOption).price
              }}{{ renderDesc(packOption).priceType }}</span
            >
          </h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PoiIcon from "../../../icons/PoiIcon.vue";

export default {
  data() {
    return {};
  },
  computed: {
    packOptions() {
      return this.getGamePack?.pack_extra_options || [];
    },
  },
  components: {
    PoiIcon,
  },
  methods: {
    renderDesc(packOption) {
      if (packOption.type === "free") {
        return {
          description: packOption.description,
          price: null,
          type: null,
          priceType: null,
        };
      } else if (packOption.type === "variable") {
        return {
          description: packOption.description,
          price: packOption.price,
          type: packOption.price_type === 0 ? "+" : "-",
          priceType: "%",
        };
      } else if (packOption.type === "fixed") {
        return {
          description: packOption.description,
          price: packOption.price,
          type: packOption.price_type === 0 ? "+" : "-",
          priceType: "$",
        };
      }
      return {
        description: packOption.description,
        price: null,
        type: null,
        priceType: null,
      };
    },
    isOptionSelected(packOption) {
      return packOption == this.getSelectedQueue?.value;
    },

    selectOption(option) {
      this.checkoutStore.setQueue(option.id);
    },
  },

  setup() {
    // ...mapGetters(["getGamePack", "getPackOptions", "getSelectedQueue"]),
    const { getGamePack } = useGameStore();
    const checkoutStore = useCheckoutStore();

    return {
      getGamePack,
      checkoutStore,
    };
  },
};
</script>
